<div class="row">
    <div class="col-12 ml-auto mr-auto">
        <div class="dash-card fund-dash">
            <ng-container *ngIf="!loading">
                <!-- <app-back-button></app-back-button> -->
            </ng-container>
            <div class="dash-card-header" style="flex-direction: column;">
                <div class="row w-100 no-gutters">
                    <div class="col-12">
                        <span>
                            fundos
                            vinculados
                        </span>
                    </div>
                </div>
            </div>

            <!-- Cards de Resumo -->
            <div class="row no-gutters">
                <div class="col-12">
                    <div class="dash-card-body"
                        style="padding-top: 16px; padding-bottom: 0;">
                        <div class="dash-card-statistics"
                            *ngIf="summary || loading">
                            <ng-container *ngIf="loading">
                                <div class="col-12 p-0">
                                    <div class="row w-100 m-0">
                                        <div class="pl-0 pr-2 col">
                                            <ngx-skeleton-loader [theme]="{
                                                height: '89px',
                                                width: '100%',
                                                margin:'0'
                                            }">
                                            </ngx-skeleton-loader>
                                        </div>

                                        <div class="px-2 col">
                                            <ngx-skeleton-loader [theme]="{
                                                height: '89px',
                                                width: '100%',
                                                margin:'0'
                                            }">
                                            </ngx-skeleton-loader>
                                        </div>

                                        <div class="px-2 col">
                                            <ngx-skeleton-loader [theme]="{
                                                height: '89px',
                                                width: '100%',
                                                margin:'0'
                                            }">
                                            </ngx-skeleton-loader>
                                        </div>

                                        <div class="px-2 col">
                                            <ngx-skeleton-loader [theme]="{
                                                height: '89px',
                                                width: '100%',
                                                margin:'0'
                                            }">
                                            </ngx-skeleton-loader>
                                        </div>

                                        <div class="pr-0 pl-2 col">
                                            <ngx-skeleton-loader [theme]="{
                                                height: '89px',
                                                width: '100%',
                                                margin:'0'
                                            }">
                                            </ngx-skeleton-loader>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="!loading && summary">
                                <div class="dash-card-statistics-item">
                                    <span class="dash-card-statistics-title">Em
                                        aprovação</span>
                                    <span class="dash-card-statistics-value">{{
                                        summary.total_in_approval }}</span>
                                </div>

                                <div class="dash-card-statistics-item">
                                    <span
                                        class="dash-card-statistics-title">Aprovados</span>
                                    <span class="dash-card-statistics-value">{{
                                        summary.total_approved }}</span>
                                </div>

                                <div class="dash-card-statistics-item">
                                    <span class="dash-card-statistics-title">
                                        Integrados
                                        <app-tooltip
                                            text="Fundos aprovados com integração ativa"
                                            position="top">
                                            <svg-icon
                                                src="assets/images/icon-info.svg"
                                                fill="var(--light)"
                                                style="margin-left: 4px; font-size: 12px; cursor: help;"></svg-icon>
                                        </app-tooltip>
                                    </span>
                                    <span class="dash-card-statistics-value">{{
                                        summary.total_integrated }}</span>
                                </div>

                                <div class="dash-card-statistics-item">
                                    <span class="dash-card-statistics-title">
                                        Não integrados
                                        <app-tooltip
                                            text="Fundos aprovados sem integração, não operacionais"
                                            position="top">
                                            <svg-icon
                                                src="assets/images/icon-info.svg"
                                                fill="var(--light)"
                                                style="margin-left: 4px; font-size: 12px; cursor: help;"></svg-icon>
                                        </app-tooltip>
                                    </span>
                                    <span class="dash-card-statistics-value">{{
                                        summary.total_not_integrated }}</span>
                                </div>

                                <div class="dash-card-statistics-item">
                                    <span
                                        class="dash-card-statistics-title">Total
                                        de fundos</span>
                                    <span class="dash-card-statistics-value">{{
                                        summary.total_funds }}</span>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>

            <div class="dash-card-header" style="flex-direction: column;">
                <div class="row w-100 no-gutters">
                    <!-- Botões de filtro com skeleton -->
                    <div class="col-12">
                        <div class="dash-card-header"
                            style="flex-direction: column; padding: 0;">
                            <div class="row no-gutters">
                                <div
                                    class="col-12 d-flex justify-content-between align-items-center mt-5 px-0">
                                    <div class="d-flex align-items-center">
                                        <button type="button"
                                            class="sort-button mr-2"
                                            (click)="refreshData()"
                                            [disabled]="loading">
                                            <svg-icon
                                                src="assets/images/icon-renew.svg"></svg-icon>
                                            <span>Atualizar</span>
                                        </button>
                                    </div>

                                    <div class="d-flex align-items-center">
                                        <ng-container
                                            *ngIf="permissionObj.canFilter">
                                            <app-button
                                                *ngIf="hasFilters && !loading"
                                                [danger]="true" [outline]="true"
                                                (onClick)="resetForm()"
                                                class="add-button mr-2">
                                                <svg-icon
                                                    src="assets/images/icon-times.svg"
                                                    class="filter-clear-icon"></svg-icon>
                                                Limpar filtros
                                            </app-button>

                                            <app-button [inverted]="true"
                                                class="add-button mr-2"
                                                (onClick)="toggleFilterModal()"
                                                [disabled]="loading">
                                                <svg-icon
                                                    src="assets/images/icon_filter.svg"
                                                    class="mr-2">
                                                </svg-icon>
                                                {{ hasFilters ? 'Editar
                                                filtros' :
                                                'Filtrar listagem' }}
                                            </app-button>
                                        </ng-container>

                                        <app-button
                                            (click)="redirectToNewFund()"
                                            class="add-button"
                                            *ngIf="permissionObj.canAdd">
                                            <svg-icon
                                                src="assets/images/icon-add.svg"
                                                class="mr-2 mt-1 mb-1"></svg-icon>
                                            Criar Fundo
                                        </app-button>
                                    </div>
                                </div>

                                <!-- Tags de filtros aplicados -->
                                <div class="col-12 mt-3 px-0"
                                    *ngIf="!loading && hasFilters && appliedFilters.length > 0">
                                    <div
                                        class="d-flex flex-wrap align-items-center justify-content-end">
                                        <app-filter-tag
                                            *ngFor="let filter of appliedFilters"
                                            [label]="filter.label"
                                            [value]="filter.value">
                                        </app-filter-tag>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="dash-card-body">
                <div class="dash-card-scroll">
                    <table class="skeleton-table" *ngIf="loading">
                        <tbody>
                            <tr *ngFor="let number of [0, 1, 2]">
                                <!-- Nome abreviado -->
                                <td>
                                    <div class="dash-card-item">
                                        <div class="dash-card-item-initials">
                                            <ngx-skeleton-loader
                                                appearance="circle" [theme]="{
                                                    height: '48px',
                                                    width: '48px',
                                                    marginBottom: '0'
                                                }">
                                            </ngx-skeleton-loader>
                                        </div>
                                        <app-spacer [right]="16"></app-spacer>
                                        <div class="dash-card-item-content">
                                            <div
                                                class="dash-card-item-content-title">
                                                <ngx-skeleton-loader [theme]="{
                                                    height: '21px',
                                                    width: '130px',
                                                    marginBottom: '0'
                                                }">
                                                </ngx-skeleton-loader>
                                            </div>
                                        </div>
                                    </div>
                                </td>

                                <!-- CNPJ -->
                                <td>
                                    <ngx-skeleton-loader [theme]="{
                                        height: '21px',
                                        width: '140px',
                                        marginBottom: '0'
                                    }">
                                    </ngx-skeleton-loader>
                                </td>

                                <!-- Classificação ANBIMA -->
                                <td>
                                    <ngx-skeleton-loader [theme]="{
                                        height: '21px',
                                        width: '120px',
                                        marginBottom: '0'
                                    }">
                                    </ngx-skeleton-loader>
                                </td>

                                <!-- Cedentes -->
                                <td>
                                    <ngx-skeleton-loader [theme]="{
                                        height: '21px',
                                        width: '80px',
                                        marginBottom: '0'
                                    }">
                                    </ngx-skeleton-loader>
                                </td>

                                <!-- Cotistas -->
                                <td>
                                    <ngx-skeleton-loader [theme]="{
                                        height: '21px',
                                        width: '80px',
                                        marginBottom: '0'
                                    }">
                                    </ngx-skeleton-loader>
                                </td>

                                <!-- Status -->
                                <td>
                                    <div class="status-badge-container">
                                        <ngx-skeleton-loader [theme]="{
                                            height: '28px',
                                            width: '120px',
                                            borderRadius: '20px',
                                            marginBottom: '0'
                                        }">
                                        </ngx-skeleton-loader>
                                    </div>
                                </td>

                                <!-- Transferência -->
                                <td>
                                    <ngx-skeleton-loader [theme]="{
                                        height: '24px',
                                        width: '100px',
                                        borderRadius: '12px',
                                        marginBottom: '0'
                                    }">
                                    </ngx-skeleton-loader>
                                </td>

                                <!-- Ações -->
                                <td style="text-align: right;">
                                    <div
                                        class="fund-actions">
                                        <ngx-skeleton-loader [theme]="{
                                            height: '20px',
                                            width: '20px',
                                            borderRadius: '4px',
                                            marginBottom: '0'
                                        }">
                                        </ngx-skeleton-loader>
                                        <ngx-skeleton-loader [theme]="{
                                            height: '20px',
                                            width: '20px',
                                            borderRadius: '4px',
                                            marginBottom: '0'
                                        }">
                                        </ngx-skeleton-loader>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <app-spacer [bottom]="28"></app-spacer>
                    </table>

                    <table *ngIf="funds.length > 0 && !loading">
                        <thead>
                            <tr>
                                <th>Nome abreviado</th>
                                <th class="fund-cnpj-col">CNPJ</th>
                                <th>Classificação ANBIMA</th>
                                <th>Cedentes</th>
                                <th>Cotistas</th>
                                <th>Status</th>
                                <th>Transferência</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let approval of funds">
                                <!-- Nome abreviado -->
                                <td>
                                    <div class="dash-card-item">
                                        <div class="dash-card-item-initials">
                                            <span>{{ getFundInitials(approval)
                                                }}</span>
                                        </div>
                                        <app-spacer [right]="16"></app-spacer>
                                        <div class="dash-card-item-content">
                                            <div
                                                class="dash-card-item-content-title">
                                                {{ approval.fund.name || '-' }}
                                            </div>
                                        </div>
                                    </div>
                                </td>

                                <!-- CNPJ -->
                                <td class="fund-cnpj-col">
                                    <div class="dash-card-item-content">
                                        <div
                                            class="dash-card-item-content-title">
                                            {{
                                            formatDocument(approval.fund.document)
                                            }}
                                        </div>
                                    </div>
                                </td>

                                <!-- Classificação ANBIMA -->
                                <td>
                                    <div class="dash-card-item-content">
                                        <div
                                            class="dash-card-item-content-title">
                                            {{
                                            approval.fund.anbima_classification_display
                                            || '-' }}
                                        </div>
                                    </div>
                                </td>

                                <!-- Cedentes -->
                                <td>
                                    <div class="dash-card-item-content">
                                        <div
                                            class="dash-card-item-content-title">
                                            {{ getAssignorsCount(approval) }}
                                        </div>
                                    </div>
                                </td>

                                <!-- Cotistas -->
                                <td>
                                    <div class="dash-card-item-content">
                                        <div
                                            class="dash-card-item-content-title">
                                            {{ getShareholdersCount(approval) }}
                                        </div>
                                    </div>
                                </td>

                                <!-- Status -->
                                <td>
                                    <div class="status-badge-container">
                                        <ng-container
                                            *ngIf="!isFundOperationallyActive(approval); else approvalStatusBadge">
                                            <app-tooltip
                                                [text]="getFundInactiveReasonTooltip(approval)"
                                                position="top">
                                                <span
                                                    class="status-badge status-badge-inactive">
                                                    Inativo
                                                </span>
                                            </app-tooltip>
                                        </ng-container>
                                        <ng-template #approvalStatusBadge>
                                            <span
                                                [class]="getStatusBadgeClass(approval)"
                                                class="status-badge">
                                                {{ getStatusForBadge(approval) }}
                                            </span>
                                            <div class="status-badge-info"
                                                *ngIf="getStatusInfo(approval)">
                                                {{ getStatusInfo(approval) }}
                                            </div>
                                        </ng-template>
                                    </div>
                                </td>

                                <!-- Transferência -->
                                <td>
                                    <div class="fund-transfer-tags">
                                        <span class="fund-transfer-tag"
                                            [class.fund-transfer-tag--confirm]="tag === 'Transferência a confirmar'"
                                            *ngFor="let tag of getFundTransferTags(approval)">
                                            {{ tag }}
                                        </span>
                                        <span *ngIf="!getFundTransferTags(approval).length">-</span>
                                    </div>
                                </td>

                                <!-- Ações -->
                                <td class="fund-actions-col">
                                    <div class="fund-actions">
                                        <app-tooltip text="Visualizar"
                                            position="top">
                                            <button type="button"
                                                class="dash-item-button"
                                                (click)="viewFund(approval, $event)">
                                                <svg-icon
                                                    src="assets/images/icon-eye.svg"></svg-icon>
                                            </button>
                                        </app-tooltip>

                                        <div class="fund-actions-menu"
                                            *ngIf="permissionObj.canChange"
                                            [class.fund-actions-menu--open]="isFundActionsOpen(approval)"
                                            (click)="$event.stopPropagation()">
                                            <app-tooltip text="Ações"
                                                position="top">
                                                <button type="button"
                                                    class="dash-item-button"
                                                    (click)="toggleFundActions(approval, $event)">
                                                    <svg-icon
                                                        src="assets/images/icon-cog.svg"></svg-icon>
                                                </button>
                                            </app-tooltip>
                                            <div class="fund-actions-menu__dropdown"
                                                *ngIf="isFundActionsOpen(approval)">
                                                <button type="button"
                                                    class="dropdown-button"
                                                    *ngIf="canEditScheduledTransfer(approval)"
                                                    (click)="openFundEditScheduleModal(approval, $event)">
                                                    Editar agendamento
                                                </button>
                                                <button type="button"
                                                    class="dropdown-button"
                                                    *ngIf="canCancelScheduledTransfer(approval)"
                                                    (click)="openCancelScheduleModal(approval, $event)">
                                                    Cancelar agendamento
                                                </button>
                                                <button type="button"
                                                    class="dropdown-button"
                                                    *ngIf="canConfirmInactivation(approval)"
                                                    (click)="openConfirmInactivationModal(approval, $event)">
                                                    Confirmar inativação
                                                </button>
                                                <button type="button"
                                                    class="dropdown-button"
                                                    *ngIf="canInactivateFund(approval)"
                                                    (click)="openFundInactivateModal(approval, $event)">
                                                    Inativar
                                                </button>
                                                <button type="button"
                                                    class="dropdown-button"
                                                    *ngIf="canReactivateFund(approval)"
                                                    (click)="openFundActivateModal(approval, $event)">
                                                    Ativar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>

                        </tbody>
                        <app-spacer [bottom]="28"></app-spacer>
                    </table>

                    <ng-container *ngIf="hasFilters">

                        <div *ngIf="funds.length === 0 && !loading">
                            <app-empty-content [isVisible]="true"
                                title="Não encontramos resultados para sua busca"
                                description="Não há registros para o termo digitado, verifique a ortografia ou tente novamente com outras palavras"
                                icon="/assets/images/figure_3d_search.png">
                            </app-empty-content>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="!hasFilters">
                        <div *ngIf="funds.length === 0 && !loading">
                            <app-empty-content [isVisible]="true"
                                [title]="applicableRole !== 'ADM' ? 'Nenhuma vínculo encontrado' : 'Nenhum fundo encontrado'"
                                [description]="applicableRole !== 'ADM' ? 'Você ainda não possui vínculos cadastrados' : 'Você ainda não possui fundos cadastrados'"
                                icon="/assets/images/star.png">
                            </app-empty-content>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="dash-card-pagination" *ngIf="funds.length > 0">
            <app-pagination [data]="funds" [show]="!loading" [count]="count"
                [offset]="offset" (onPageChange)="changePageData($event)"
                [resultsPerPage]="results_per_page" [dashPagination]="true">
            </app-pagination>
        </div>
    </div>

    <app-side-filter-modal [active]="showFilterModal" [formGroup]="filterForm"
        [loading]="loading" title="Filtrar listagem" (onClose)="closeModal()"
        [disableApplyButton]="!hasFilterValues()" (onApply)="filterData()"
        (onReset)="resetForm()">
        <div class="row">
            <div class="col-12">
                <app-input label="Por Nome / CNPJ" [group]="filterForm"
                    controlName="search">
                </app-input>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12">
                <app-select [items]="anbimaChoices" [group]="filterForm"
                    controlName="fund_type" placeholder="Selecione"
                    label="Por classificação ANBIMA" [multiple]="true">
                </app-select>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-6">
                <app-select [items]="statusChoices" [group]="filterForm"
                    controlName="status_option" placeholder="Selecione"
                    label="Por status">
                </app-select>
                <app-spacer [bottom]="32"></app-spacer>
            </div>

            <div class="col-6">
                <app-select [items]="transferTypeChoices" [group]="filterForm"
                    controlName="transfer_option" placeholder="Selecione"
                    label="Por tipo de transferência">
                </app-select>
                <app-spacer [bottom]="32"></app-spacer>
            </div>

        </div>
    </app-side-filter-modal>

    <!-- Carbon Warning Modals -->
    <app-carbon-warning-modal [active]="showDeleteModal"
        [title]="getDeleteModalTitle()" [message]="getDeleteModalMessage()"
        [confirmText]="getDeleteConfirmText()"
        [cancelText]="getDeleteCancelText()"
        [confirmAction]="confirmDeleteFund.bind(this)"
        [cancelAction]="closeDeleteModal.bind(this)"
        (onClose)="closeDeleteModal()">
    </app-carbon-warning-modal>

    <app-carbon-warning-modal [active]="showSuccessModal"
        [title]="getSuccessModalTitle()" [message]="getSuccessModalMessage()"
        [confirmText]="getSuccessConfirmText()" [cancelText]="''"
        [confirmAction]="closeSuccessModal.bind(this)"
        [cancelAction]="closeSuccessModal.bind(this)"
        (onClose)="closeSuccessModal()">
    </app-carbon-warning-modal>

    <app-carbon-warning-modal [active]="showErrorModal"
        [title]="getErrorModalTitle()" [message]="getErrorModalMessage()"
        [confirmText]="getErrorConfirmText()" [cancelText]="''"
        [confirmAction]="closeErrorModal.bind(this)"
        [cancelAction]="closeErrorModal.bind(this)"
        (onClose)="closeErrorModal()">
    </app-carbon-warning-modal>

    <app-carbon-warning-modal [active]="showCancelScheduleModal"
        title="Cancelar agendamento"
        message="Tem certeza que deseja cancelar o agendamento de inativação deste fundo?"
        confirmText="Sim, cancelar" cancelText="Não, manter agendamento"
        [loading]="scheduleActionLoading"
        loadingText="Cancelando agendamento..."
        loadingConfirmText="Cancelando..."
        [skipAutoCloseOnConfirm]="true"
        [confirmAction]="confirmCancelSchedule.bind(this)"
        [cancelAction]="closeCancelScheduleModal.bind(this)"
        (onClose)="closeCancelScheduleModal()">
    </app-carbon-warning-modal>

    <app-carbon-warning-modal [active]="showConfirmInactivationModal"
        title="Atenção"
        message="Esta ação <strong>não poderá ser desfeita</strong>. O fundo será <strong>inativado imediatamente</strong>, junto com os cedentes e cotistas vinculados."
        confirmText="Confirmar inativação" cancelText="Cancelar"
        [loading]="scheduleActionLoading"
        loadingText="Inativando fundo..."
        loadingConfirmText="Inativando..."
        [skipAutoCloseOnConfirm]="true"
        [confirmAction]="confirmScheduledInactivationFromList.bind(this)"
        [cancelAction]="closeConfirmInactivationModal.bind(this)"
        (onClose)="closeConfirmInactivationModal()">
    </app-carbon-warning-modal>

    <app-fund-operational-status-modal
        [fund]="selectedFundApproval?.fund"
        [mode]="fundOperationalModalMode"
        [prefill]="fundOperationalPrefill"
        (closed)="closeFundOperationalModal()"
        (statusChanged)="onFundOperationalStatusChanged()">
    </app-fund-operational-status-modal>
</div>
